<div class="sm-input-field">
  @if (label || (required && requiredText)) {
    <span class="sm-input-field__label-row">
      @if (labelOverflowTooltip) {
        <sm-overflow-tooltip class="sm-input-field__label" [text]="label">
          {{ label }}
        </sm-overflow-tooltip>
      } @else {
        <span class="sm-input-field__label" [attr.title]="label || null">{{ label }}</span>
      }
      @if (required && requiredText) {
        <span class="sm-input-field__required">{{ requiredText }}</span>
      }
    </span>
  }

  <div
    class="sm-input"
    [class.sm-input--invalid]="invalid"
    [class.sm-input--readonly]="readonly"
    [class.sm-input--disabled]="disabled"
    [class.sm-input--with-side-slot]="hasSideSlot">
    <ion-input
      [type]="type"
      [color]="'primary'"
      [value]="displayValue !== null ? displayValue : value"
      [placeholder]="placeholder"
      [attr.aria-label]="ariaLabel || null"
      [autocomplete]="autocomplete"
      [inputmode]="inputmode"
      [autocapitalize]="autocapitalize"
      [readonly]="readonly"
      [disabled]="disabled"
      (ionInput)="handleInput($event)"
      (ionBlur)="handleBlur()">
    </ion-input>

    <ng-content></ng-content>
  </div>
</div>

@if (errorText) {
  <p class="sm-input-field__error" [id]="errorId" role="alert">{{ errorText }}</p>
}
